<script setup lang="ts">
const open = defineModel<boolean>("open", { default: false });

const { t } = useI18n();

const triggerRef = useTemplateRef<{ $el: HTMLElement } | null>("trigger");

watch(open, (next, prev) => {
  if (prev && !next) {
    nextTick(() => triggerRef.value?.$el?.focus?.());
  }
});
</script>

<template>
  <AppScrollRow>
    <UButton
      ref="trigger"
      variant="outline"
      color="primary"
      trailing-icon="icon:filter"
      class="shrink-0"
      :aria-expanded="open"
      aria-haspopup="dialog"
      @click="() => { open = true }"
    >
      {{ t("ui.filters.title") }}
    </UButton>

    <slot name="chips" />
  </AppScrollRow>
</template>
